export const DOWNLOAD_EXTENSION_URL =
  "https://github.com/insight-extension/insight/releases/latest/download/extension.zip";

export const INSTALLATION_INSTRUCTION_URL =
  "https://docs.google.com/document/d/1OjDxbyfzQcKPAbubk_NmKqP_nlT30tDaBYO5GRlmQSQ/edit?usp=sharing";
